import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { FormListEntity } from 'entities/FormList';
import { FormListPageStore } from 'stores/local';
import { toDDMMYYYFormat } from 'utils/date';

import { SetupColumn, StatusColumn } from './components';

/** Индексы колонок, используются в качестве ключей при сортировке таблицы */
const DATA_INDICES = {
  NAME: 'name',
  STATUS: 'status',
  START_DATETIME: 'start_datetime',
  FINISH_DATETIME: 'finish_datetime',
};

export const useColumns = (
  store: FormListPageStore
): ColumnsType<FormListEntity> => {
  const { t } = useTranslation();

  return React.useMemo(
    () => [
      {
        title: t('formList.columns.name'),
        sorter: true,
        dataIndex: DATA_INDICES.NAME,
        key: 'name',
        className: 'form-list-table__column-name',
        render: (_, record) => <Typography.Text>{record.name}</Typography.Text>,
      },
      {
        title: t('formList.columns.status'),
        sorter: true,
        dataIndex: DATA_INDICES.STATUS,
        key: 'status',
        render: (_, record) => <StatusColumn entity={record} />,
      },
      {
        title: t('formList.columns.startDate'),
        sorter: true,
        dataIndex: DATA_INDICES.START_DATETIME,
        key: 'startDatetime',
        render: (_, record) => (
          <Typography.Text>
            {record.startDatetime
              ? toDDMMYYYFormat(record.startDatetime)
              : t('formList.noDate')}
          </Typography.Text>
        ),
      },
      {
        title: t('formList.columns.endDate'),
        sorter: true,
        dataIndex: DATA_INDICES.FINISH_DATETIME,
        key: 'finishDatetime',
        render: (_, record) => (
          <Typography.Text>
            {record.finishDatetime
              ? toDDMMYYYFormat(record.finishDatetime)
              : t('formList.noDate')}
          </Typography.Text>
        ),
      },
      {
        title: '',
        dataIndex: 'setup',
        key: 'setup',
        render: (_, record) => <SetupColumn entity={record} store={store} />,
      },
    ],
    [store, t]
  );
};
